import styled from '@emotion/styled'

export const LeftNavigationGradientOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 16px;
  height: 100%;
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.02) 70%, rgba(0, 0, 0, 0.05) 100%);
`
